import { Checkbox, Flex, Text } from '@chakra-ui/react'
import { DocumentReference, deleteField, setDoc } from 'firebase/firestore'

import FirestoreUser from '../../../../types/FirestoreUser'
import { formatDateString } from '../../../../utils/formatDate'

interface Props {
  profile: FirestoreUser['profile']
  userRef: DocumentReference<FirestoreUser>
  adminInitials: string
}

export function DiagnosisVerificationControls({
  profile,
  userRef,
  adminInitials,
}: Props) {
  function handleDiagnosisVerifiedChange() {
    const currentDate = new Date().toISOString().split('T')[0]
    const isCurrentlyVerified = !!profile?.diagnosisVerified

    if (isCurrentlyVerified) {
      setDoc(
        userRef,
        {
          profile: {
            diagnosisVerified: false,
            diagnosisVerificationDate: deleteField(),
            diagnosisVerifiedBy: deleteField(),
          },
        },
        { merge: true }
      )
    } else {
      setDoc(
        userRef,
        {
          profile: {
            diagnosisVerified: true,
            diagnosisVerificationDate: currentDate,
            diagnosisVerifiedBy: adminInitials,
          },
        },
        { merge: true }
      )
    }
  }

  function handleDiagnosisDateVerifiedChange() {
    const currentDate = new Date().toISOString().split('T')[0]
    const isCurrentlyDateVerified = !!profile?.diagnosisDateVerified

    if (isCurrentlyDateVerified) {
      setDoc(
        userRef,
        {
          profile: {
            diagnosisDateVerified: false,
            diagnosisDateVerificationDate: deleteField(),
            diagnosisDateVerifiedBy: deleteField(),
          },
        },
        { merge: true }
      )
    } else {
      setDoc(
        userRef,
        {
          profile: {
            diagnosisDateVerified: true,
            diagnosisDateVerificationDate: currentDate,
            diagnosisDateVerifiedBy: adminInitials,
          },
        },
        { merge: true }
      )
    }
  }

  return (
    <>
      <Flex alignItems='center' gap={3}>
        <Checkbox
          isChecked={!!profile?.diagnosisVerified}
          onChange={handleDiagnosisVerifiedChange}
        >
          Diagnosis Verified
        </Checkbox>
        {profile?.diagnosisVerificationDate && (
          <Text fontSize='sm' color='gray.600'>
            {formatDateString(profile.diagnosisVerificationDate)}
          </Text>
        )}
      </Flex>

      <Flex alignItems='center' gap={3} mt={2}>
        <Checkbox
          isChecked={!!profile?.diagnosisDateVerified}
          onChange={handleDiagnosisDateVerifiedChange}
        >
          Diagnosis Date Verified
        </Checkbox>
        {profile?.diagnosisDateVerificationDate && (
          <Text fontSize='sm' color='gray.600'>
            {formatDateString(profile.diagnosisDateVerificationDate)}
          </Text>
        )}
      </Flex>
    </>
  )
}
